import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconTeam = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 4.5,
			cy: 12.5,
			r: 2.7,
			stroke: "currentColor",
			strokeWidth: 1.6
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 5.5,
			r: 2.7,
			stroke: "currentColor",
			strokeWidth: 1.6
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13.5,
			cy: 12.5,
			r: 2.7,
			stroke: "currentColor",
			strokeWidth: 1.6
		})
	]
});
export default SvgIconTeam;
